module.exports = __webpack_public_path__ + "media/images/msec_4-1-5809ca98e63395b7f75e21dfd427367f.png";